export function paymentLegalEntityDataCookie() {
    const formCookie = useCookie('paymentLegalEntityForm')
    function getLegalEntityData() {
        return formCookie
    }

    function setLegalEntityData(data: LegalEntitiesInterface | null) {
        formCookie.value = data
    }

    return {getLegalEntityData, setLegalEntityData}
}